import { useState } from 'react';

export default function Features() {
  const [expandedCard, setExpandedCard] = useState(0);

  const features = [
    {
      title: 'Advanced Security',
      description: 'Military-grade encryption protocols protect your data and privacy across all our applications',
      image: 'https://public.readdy.ai/ai/img_res/2ff71a0240e4b449b56ac2f895a7e13f.jpg'
    },
    {
      title: 'Optimized Performance',
      description: 'Lightning-fast processing and efficient resource management for seamless user experience',
      image: 'https://readdy.ai/api/search-image?query=abstract%20speed%20and%20performance%20concept%20with%20flowing%20energy%20lines%2C%20gradient%20purple%20and%20pink%20mesh%20background%2C%20lightning%20bolt%20patterns%2C%20dynamic%20motion%20blur%2C%20futuristic%20interface%20elements%2C%20high-tech%20aesthetic%2C%20professional%20corporate%20design%2C%20glowing%20effects&width=600&height=800&seq=feat-perf-001&orientation=portrait'
    },
    {
      title: 'Intuitive Design',
      description: 'Beautiful interfaces crafted with attention to detail for effortless navigation and control',
      image: 'https://readdy.ai/api/search-image?query=abstract%20modern%20UI%20design%20concept%20with%20geometric%20shapes%20and%20gradients%2C%20soft%20teal%20and%20green%20mesh%20background%2C%20minimalist%20interface%20elements%2C%20clean%20design%20patterns%2C%20futuristic%20aesthetic%2C%20professional%20corporate%20design%2C%20smooth%20gradients&width=600&height=800&seq=feat-ui-001&orientation=portrait'
    }
  ];

  return (
    <section id="features" className="relative py-32 px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-5xl font-bold text-gray-900 mb-16 flex items-center gap-3">
          Core Features <span className="text-4xl">⚡</span>
        </h2>

        <div className="grid grid-cols-10 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
                expandedCard === index ? 'col-span-4' : 'col-span-3'
              }`}
              style={{ aspectRatio: '3/4' }}
              onMouseEnter={() => setExpandedCard(index)}
            >
              <img 
                src={feature.image}
                alt={feature.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <h3 className="text-3xl font-bold text-white mb-4">{feature.title}</h3>
                <p className={`text-base text-white leading-relaxed transition-opacity duration-300 ${
                  expandedCard === index ? 'opacity-100' : 'opacity-0'
                }`}>
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}